import React, { useState } from "react";
import Link from "next/link";
import { TeaserData } from "./teaser";
import { CollectiveBoxTeaserEntry } from "../helper/interfaces";
import CustomImage from "./ui/Image";

export default function TeaserCollectiveBox(data: TeaserData) {
  const teaser = data.teaser as CollectiveBoxTeaserEntry;
  const [activeItem, setActiveItem] = useState(0);

  function onPrevClick(e) {
    setActiveItem(activeItem >= teaser.teasers.length ? 0 : activeItem + 1);
  }

  function onNextClick(e) {
    setActiveItem(activeItem <= 0 ? teaser.teasers.length - 1 : activeItem - 1);
  }

  return (
    <React.Fragment>
      {teaser.teasers?.length > 0 && (
        <div className="teaser-cb">
          {teaser?.title && <h5 className="teaser-cb__title">{teaser.title}</h5>}
          <div className="teaser-cb__content">
            <div className="teaser-cb__slideshow">
              {teaser.teasers.map((slide, i) => (
                <Link
                  key={`teaser-link-${slide.imageUrl}}-${i}`}
                  href={slide.linkButtonUrl ?? ''}
                  className="teaser-cb__slideshow__item"
                  style={{ display: activeItem == i ? "block" : "none" }}
                  target={slide.linkButtonUrl ? "_blank" : undefined}
                  rel={slide.linkButtonUrl ? "noreferrer" : undefined}
                >
                  {/* <a href={slide.linkButtonUrl} className="teaser-cb__slideshow__item" style={{ display: activeItem == i ? 'block' : 'none' }}> */}
                  {slide.imageUrl && (
                    <div className="teaser-cb__slideshow__item__image">
                      <div className="relative aspect-w-2 aspect-h-3">
                        <CustomImage
                          src={slide.imageUrl}
                          fill
                          className="object-cover"
                          alt={teaser.title || "slide"}
                        />
                      </div>
                    </div>
                  )}
                  {slide.linkButtonText && (
                    <div className="teaser-cb__slideshow__footer">
                      <div className="btn btn-primary">
                        {slide.linkButtonText}
                      </div>
                    </div>
                  )}
                  {/* </a> */}
                </Link>
              ))}
            </div>
            {teaser.teasers && teaser.teasers.length > 1 && (
              <>
                <button
                  className="teaser-cb__control teaser-cb__control--prev"
                  onClick={onPrevClick}
                  aria-label="Vorheriger Eintrag"
                >
                  <span className="icon-pfeil"></span>
                </button>
                <button
                  className="teaser-cb__control teaser-cb__control--next"
                  onClick={onNextClick}
                  aria-label="Nächster Eintrag"
                >
                  <span className="icon-pfeil"></span>
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
